import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollToPlugin);

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.formId = this.getAttribute('form-id');
    this.originalForm = null;
    this.stickyAddToCartButton = null;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    this.originalForm = document.getElementById(this.formId);
    this.stickyAddToCartButton = this.querySelector('.sticky-add-to-cart__button');

    if (!this.originalForm) {
      console.error('Could not find original product form elements');
      return;
    }

    this.setupEventListeners();
  }


  setupEventListeners() {
    this.setupVisibilityObserver();
    this.setupButtonClickHandler();
  }

  setupVisibilityObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove('visible');
        } else {
          const rect = entry.target.getBoundingClientRect();
          if (rect.bottom < 0) {
            this.classList.add('visible');
          } else {
            this.classList.remove('visible');
          }
        }
      });
    }, {
      threshold: [0, 1],
    });

    this.observer.observe(this.originalForm);
  }

  setupButtonClickHandler() {
    this.stickyAddToCartButton.addEventListener('click', (e) => {
      e.preventDefault();

      const mainSubmitButton = this.originalForm.querySelector('.product-form__submit-pdp');

      if (mainSubmitButton) {
        mainSubmitButton.click();
      } else {
        console.error('Could not find main product form submit button');
      }
    });
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);